<div class="absolute inset-0">
  <div class="relative container m-auto flex flex-col h-full justify-between ">

    <div class="grow overflow-y-auto">

      <div *ngIf="loading" class="bg-slate-800 rounded-lg text-center p-6">
        <fa-icon icon="circle-notch" [spin]="true" size="3x"></fa-icon>
      </div>

      <div *ngIf="!loading && groupmates" class="bg-slate-800 rounded-lg">

        <mat-paginator (page)="handlePageEvent($event)"
                       [length]="groupmates.totalElements"
                       [pageSize]="groupmates.pageable.pageSize"
                       [showFirstLastButtons]="true"
                       [hidePageSize]="true"
                       [pageIndex]="groupmates.pageable.pageNumber"
                       aria-label="Select page">
        </mat-paginator>

        <div *ngFor="let groupmate of groupmates.content">
          <app-user-summary [user]="groupmate.user" [groupmateSummary]="groupmate" (tagClicked)="handleTagClicked($event)"></app-user-summary>
        </div>
      </div>
    </div>

    <div>
      <app-menu-bar *ngIf="user" location="groupmates"></app-menu-bar>
    </div>
  </div>
  <app-footer></app-footer>
</div>
